export const axiosError  = {
  create: (error) => {
    if (!error.response) {
      return [{ title: "Ingen anslutning kunde göras kompetenskortstjänsten"}];
    }

    return error.response.data.errors;
  }
};
